/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class MethodAttributes.
* @enum {}
* @readonly
*/
export default class MethodAttributes {
    
        /**
         * value: 0
         * @const
         */
        "0" = 0;

    
        /**
         * value: 1
         * @const
         */
        "1" = 1;

    
        /**
         * value: 2
         * @const
         */
        "2" = 2;

    
        /**
         * value: 3
         * @const
         */
        "3" = 3;

    
        /**
         * value: 4
         * @const
         */
        "4" = 4;

    
        /**
         * value: 5
         * @const
         */
        "5" = 5;

    
        /**
         * value: 6
         * @const
         */
        "6" = 6;

    
        /**
         * value: 7
         * @const
         */
        "7" = 7;

    
        /**
         * value: 8
         * @const
         */
        "8" = 8;

    
        /**
         * value: 16
         * @const
         */
        "16" = 16;

    
        /**
         * value: 32
         * @const
         */
        "32" = 32;

    
        /**
         * value: 64
         * @const
         */
        "64" = 64;

    
        /**
         * value: 128
         * @const
         */
        "128" = 128;

    
        /**
         * value: 256
         * @const
         */
        "256" = 256;

    
        /**
         * value: 512
         * @const
         */
        "512" = 512;

    
        /**
         * value: 1024
         * @const
         */
        "1024" = 1024;

    
        /**
         * value: 2048
         * @const
         */
        "2048" = 2048;

    
        /**
         * value: 4096
         * @const
         */
        "4096" = 4096;

    
        /**
         * value: 8192
         * @const
         */
        "8192" = 8192;

    
        /**
         * value: 16384
         * @const
         */
        "16384" = 16384;

    
        /**
         * value: 32768
         * @const
         */
        "32768" = 32768;

    
        /**
         * value: 53248
         * @const
         */
        "53248" = 53248;

    

    /**
    * Returns a <code>MethodAttributes</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/MethodAttributes} The enum <code>MethodAttributes</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

